import { render } from "./FeeModalSectionGeneral.vue?vue&type=template&id=3501b324"
import script from "./FeeModalSectionGeneral.vue?vue&type=script&lang=js"
export * from "./FeeModalSectionGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__